<script>
import Address from '@/extensions/restrictedArea/views/Member/Form/Partials/Address'
import { useShopPosStore } from '@/stores'

export default {
    name: 'Address',
    extends: Address,
    data() {
        return {
            // accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
            // germany: [10.4515, 51.1657],
            // center: [10.4515, 51.1657],
            // zoom: 3.6,
            // showMap: false,
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: false,
        },
        showDefaultSwitches: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        validationPath() {
            return 'address'
        },
        memberStore() {
            return useShopPosStore();
        },
    }
}
</script>
